export type RoleInfo = {
  title: string;
  tagline: string;
  description: string;
};

export const ROLE_ORDER = ['collector', 'approacher', 'mago'] as const;

export const PREVIEW_ROLES = new Set<string>(['approacher', 'mago']);

export const ROLE_DESCRIPTIONS: Record<string, RoleInfo> = {
  admin: {
    title: 'Admins',
    tagline: 'El cerebro detrás del juego',
    description:
      'Coordinan al equipo, definen la estrategia y mantienen el sistema funcionando. Son los arquitectos de The 3333 Games.',
  },
  collector: {
    title: 'Collectors',
    tagline: 'La primera línea del juego',
    description:
      'Encuentran nuevos creadores en Instagram y los añaden al sistema. Son los ojos del equipo, los que descubren joyas escondidas todos los días.',
  },
  approacher: {
    title: 'Approachers',
    tagline: 'Convierten descubrimiento en oportunidad',
    description:
      'Contactan a los creadores recolectados, abren la conversación y construyen la primera relación. Solo los collectors más constantes llegan aquí.',
  },
  mago: {
    title: 'Magos',
    tagline: 'El nivel más alto del juego',
    description:
      'Cierran los acuerdos y transforman conversaciones en colaboraciones reales. Son los que hacen que todo el trabajo del equipo se materialice. Pocos llegan, los mejores se quedan.',
  },
  pre_collectors: {
    title: 'Pre Collectors',
    tagline: 'Haciendo la prueba final de acceso',
    description:
      'Acaban de unirse y están completando su primera misión. Si superan la prueba, se convertirán en Collectors.',
  },
} as const;
